// Gray Contracting - Company Information
export const companyInfo = {
  name: "Gray Contracting",
  tagline: "Quality Painting & Remodeling You Can Trust",
  phone: "214-908-7644",
  textPhone: "214-908-7644", // Owner's direct number for SMS (not tracked by CallRail)
  email: "info@graycontractingdfw.com",
  addressStreet: "4300 N Central Expy",
  addressCity: "Dallas",
  addressState: "TX",
  addressZip: "75206",
  addressFull: "4300 N Central Expy, Dallas, TX 75206",
  experience: "55+",
  founded: "1969",
  description: "Gray Contracting is a family-owned and operated business with over 55 years of experience in residential painting, remodeling, and contracting services across the Dallas-Fort Worth metroplex.",
  logoDark: "https://customer-assets.emergentagent.com/job_gray-remodel-seo/artifacts/1mpyl528_Gray%20logo.png",
  logoLight: "https://customer-assets.emergentagent.com/job_gray-remodel-seo/artifacts/bd5e3tge_company%20logo%202020%20%281%29.jpg"
};

export const credentials = [
  "55+ Years Experience",
  "Family Owned & Operated",
  "Fully Licensed & Insured",
  "Lead & Mold Certified"
];

export const serviceAreas = [
  "Dallas", "Plano", "Garland", "Mesquite", "Frisco", 
  "Rockwall", "Heath", "Richardson", "Wylie", "Sachse", 
  "Las Colinas", "Irving", "Southlake", "Grapevine", "Colleyville"
];

// Services list - basic info only
export const servicesList = [
  { id: "residential-painting", title: "Residential Painting Services", shortTitle: "Painting" },
  { id: "remodeling-renovations", title: "Remodeling & Renovations", shortTitle: "Remodeling" },
  { id: "drywall-repair", title: "Drywall Repair & Installation", shortTitle: "Drywall" },
  { id: "carpentry", title: "Carpentry Services", shortTitle: "Carpentry" },
  { id: "tile-installation", title: "Tile Installation", shortTitle: "Tile" },
  { id: "exterior-siding", title: "Exterior Siding", shortTitle: "Siding" },
  { id: "deck-construction", title: "Deck Construction", shortTitle: "Decks" },
  { id: "mold-remediation", title: "Mold Remediation", shortTitle: "Mold" },
  { id: "parking-lot-striping", title: "Parking Lot Striping & Asphalt", shortTitle: "Striping" },
  { id: "brick-masonry", title: "Brick & Masonry Services", shortTitle: "Masonry" },
  { id: "roof-repairs", title: "Roof & Exterior Leak Repairs", shortTitle: "Roofing" }
];
